import {
  CUSTOMER_INQUIRIES_REQUEST,
  CUSTOMER_INQUIRIES_RESPONSE,
  CUSTOMER_INQUIRY_REQUEST,
  CUSTOMER_INQUIRY_RESPONSE,
} from '../actions/customerInquiry.actions';

export default function customerInquiries(
  state = {
    answeredInquiries: [],
    notAnsweredInquiries: [],
    inquiryDetail: {answer: {}},
  },
  action
) {
  switch (action.type) {
    case CUSTOMER_INQUIRIES_REQUEST: {
      let nextState = {...state};
      nextState.answered = [];
      nextState.nonAnswered = [];
      return nextState;
    }
    case CUSTOMER_INQUIRIES_RESPONSE: {
      let nextState = {...state};
      nextState.answeredInquiries = action.answered;
      nextState.notAnsweredInquiries = action.notAnswered;
      return nextState;
    }

    case CUSTOMER_INQUIRY_REQUEST: {
      let nextState = {...state};
      nextState.inquiryDetail = {};
      return nextState;
    }

    case CUSTOMER_INQUIRY_RESPONSE: {
      let nextState = {...state};
      nextState.inquiryDetail = action.inquiry;
      return nextState;
    }
  }
  return state;
}
